import React from 'react';

import { Image } from '@mantine/core';
import {
  IconBrandDiscord,
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandWhatsapp,
  IconMessageCircle
} from '@tabler/icons-react';
import messagingImage from 'assets/images/onboarding/messaging.png';
import { OnboardingStepTemplate } from 'pages/Onboarding/OnboardingSteps/OnboardingStepTemplate';
import { useTranslation } from 'react-i18next';
import { OnboardingLearnMoreInterestsData } from 'shared/interfaces/Onboarding';

const LINKS = {
  WHATSAPP: 'https://docs.droxy.ai/documentation/agents/messaging/whatsapp',
  FACEBOOK: 'https://docs.droxy.ai/documentation/agents/messaging/facebook',
  INSTAGRAM: 'https://docs.droxy.ai/documentation/agents/messaging/instagram',
  DISCORD: 'https://docs.droxy.ai/documentation/agents/messaging/discord'
};

interface MessagingSmartAssistantsStepProps {
  updateOnboardingLearnMoreInterestData: (data: Partial<OnboardingLearnMoreInterestsData>) => void;
}

export function MessagingSmartAssistantsStep({
  updateOnboardingLearnMoreInterestData
}: MessagingSmartAssistantsStepProps) {
  const { t } = useTranslation();

  const updateLearnMoreInterestData = (type: 'whatsApp' | 'facebook' | 'instagram' | 'discord') => {
    switch (type) {
      case 'whatsApp':
        return updateOnboardingLearnMoreInterestData({ whatsAppSmartAssistant: true });
      case 'facebook':
        return updateOnboardingLearnMoreInterestData({ facebookSmartAssistant: true });
      case 'instagram':
        return updateOnboardingLearnMoreInterestData({ instagramSmartAssistant: true });
      case 'discord':
        return updateOnboardingLearnMoreInterestData({ discordSmartAssistant: true });
    }
  };

  return (
    <OnboardingStepTemplate
      title={{
        text: t('ONBOARDING.MESSAGING_SMART_ASSISTANTS_STEP.TITLE'),
        icon: <IconMessageCircle />
      }}
      description={t('ONBOARDING.MESSAGING_SMART_ASSISTANTS_STEP.DESCRIPTION')}
      additionalLinks={{
        title: t('ONBOARDING.MESSAGING_SMART_ASSISTANTS_STEP.ADDITIONAL_LINKS.TITLE'),
        links: [
          {
            title: t('ONBOARDING.MESSAGING_SMART_ASSISTANTS_STEP.ADDITIONAL_LINKS.WHATSAPP'),
            href: LINKS.WHATSAPP,
            icon: <IconBrandWhatsapp />,
            onClick: () => updateLearnMoreInterestData('whatsApp')
          },
          {
            title: t('ONBOARDING.MESSAGING_SMART_ASSISTANTS_STEP.ADDITIONAL_LINKS.FACEBOOK'),
            href: LINKS.FACEBOOK,
            icon: <IconBrandFacebook />,
            onClick: () => updateLearnMoreInterestData('facebook')
          },
          {
            title: t('ONBOARDING.MESSAGING_SMART_ASSISTANTS_STEP.ADDITIONAL_LINKS.INSTAGRAM'),
            href: LINKS.INSTAGRAM,
            icon: <IconBrandInstagram />,
            onClick: () => updateLearnMoreInterestData('instagram')
          },
          {
            title: t('ONBOARDING.MESSAGING_SMART_ASSISTANTS_STEP.ADDITIONAL_LINKS.DISCORD'),
            href: LINKS.DISCORD,
            icon: <IconBrandDiscord />,
            onClick: () => updateLearnMoreInterestData('discord')
          }
        ]
      }}
      rightElement={<Image src={messagingImage} maw={400} />}
    />
  );
}
